import React, { FunctionComponent } from 'react';
import classnames from 'classnames';

import { Heading, P } from '@savebetter/components';

import { PageSectionBlok, PageSectionProps } from './PageSection';
import { Section } from './Section';

interface Blok extends PageSectionBlok {
  title?: string;
  description?: string;
  embedVideo: string;
}

interface MediaFrameProps extends PageSectionProps {
  blok: Blok;
}

const sectionClasses = (sectionClassName?: string): string => classnames('flex justify-center', sectionClassName);

export const MediaFrame: FunctionComponent<React.PropsWithChildren<MediaFrameProps>> = ({ blok, sectionClassName }) => {
  const { hasBackground, hasBorder, title, description, embedVideo, hasPaddingTop, hasPaddingBottom } = blok;

  const videoSrc = embedVideo.split(' ').filter(str => str.indexOf('src=') !== -1)[0];
  const videoUrl = videoSrc ? videoSrc.slice(5, -1) : '';

  return (
    <Section
      width="md"
      hasBackground={hasBackground}
      className={sectionClasses(sectionClassName)}
      hasBorder={hasBorder}
      blok={blok}
      hasPaddingBottom={hasPaddingBottom}
      hasPaddingTop={hasPaddingTop}
    >
      <div className="flex justify-center ">
        <div className="lg:w-2/3 md:w-5/6 sm:w-full h-auto">
          {title && (
            <Heading className="text-center lg:pb-16 pb-8" kind="2" level="3">
              {title}
            </Heading>
          )}

          <iframe
            title="embed video"
            className="w-full lg:h-100 md:h-78 sm:h-48"
            src={videoUrl}
            frameBorder="0"
            loading="lazy"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
          {description && <P className="lg:pt-8 md:pt-6 sm:pt-7">{description}</P>}
        </div>
      </div>
    </Section>
  );
};
